export default __webpack_public_path__ + "static/media/singular1.e07e510d.png";